module.exports = __webpack_public_path__ + "static/media/Pin-Selected.c11c1cd7.svg";